import { searchTextFilterAtom } from 'atoms/filters/esim-products';
import {
  TableLayoutFilters,
  TableLayoutSearchInput,
} from 'common/components/Layouts/TableLayout/TableLayout';
import { useTranslation } from 'react-i18next';
import { useDebouncedIdSearch } from 'src/common/components/Filters/hooks/useDebouncedIdSearch';

import { TextField } from 'src/common/components/Inputs/TextField/TextField';

export const ESimFilters = () => {
  const { t } = useTranslation();
  const { inputValue, onChange } = useDebouncedIdSearch({
    searchTextFilterAtom,
  });

  return (
    <TableLayoutFilters showBorder>
      <TableLayoutSearchInput>
        <TextField
          value={inputValue}
          onChange={(e) => onChange(e.target.value)}
          label={t('products.eSim.filters.search')}
          showSearchIcon={true}
          placeholder={t('products.eSim.filters.search')}
        />
      </TableLayoutSearchInput>
    </TableLayoutFilters>
  );
};
